import React from 'react';
import { useLocalization } from '../../context/Localization/localization';
import { CTAButton } from '../../controls/ButtonBase';
import { IconButton } from '../../controls/IconButton/IconButton';
import { Page } from '../Layout/Page/Page';
import { ScrollableBody } from '../Layout/ScrollableBody/ScrollableBody';
import css from './SaveSession.module.scss';
import { GMButtonGroup } from '../../controls/ButtonGroup';
import { GMSizedIcon } from '../../controls/Icon';
import { useSavedSessionFinish, useSavedSessionLoad } from '../../context/SavedSession/Hooks';

export const ContinueSavedSessionWeb = React.memo(() => {
    const Localization = useLocalization();
    const { clearSession } = useSavedSessionFinish();
    const { loadSession } = useSavedSessionLoad();

    return (
        <Page
            customHeaderProps={{
                title: Localization.ContinueSession,
                rightIcons: [
                    <IconButton
                        sizedIcon={
                            <GMSizedIcon
                                iconType={'Close'}
                                iconSize={'medium'}
                                ariaLabel={Localization.CloseIcon}
                                title={Localization.ClickToCloseWindow}
                            />
                        }
                        onClick={() => clearSession()}
                        ariaLabel={Localization.ClickToCloseWindow}
                        id={Localization.ClickToCloseWindow}
                    />,
                ],
            }}
        >
            <ScrollableBody>
                <h2 className={css.savedSessionTitle}>{Localization.ContinueFromWhereYouLeft}</h2>
            </ScrollableBody>
            <GMButtonGroup
                buttons={[
                    (
                        <CTAButton
                            styleType={'primary'}
                            onClick={() => loadSession()}
                            label={Localization.YesContinueSession}
                            id={Localization.YesContinueSession}
                            ariaLabel={Localization.YesContinueSession}
                        />
                    ),
                    (
                        <CTAButton
                            styleType={'secondary'}
                            onClick={() => clearSession()}
                            label={Localization.NoStartOver}
                            ariaLabel={Localization.NoStartOver}
                            id={Localization.NoStartOver}
                        />
                    ),
                ]}
            />
        </Page>
    );
});
